import { render } from "./DiapoComponent.vue?vue&type=template&id=66dd1cbc&scoped=true"
import script from "./DiapoComponent.vue?vue&type=script&lang=js"
export * from "./DiapoComponent.vue?vue&type=script&lang=js"

import "./DiapoComponent.vue?vue&type=style&index=0&id=66dd1cbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66dd1cbc"]])

export default __exports__